import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { formatTeamsData } from "./ChartBuilder/teamFilterComponents";

const TeamFilterHierarchyOutlined = ({
  label,
  value,
  onChange,
  name,
  options,
  disabled,
  labelColorCondition,
  renderValue,
  getOptionLabel,
  getOptionValue,
  data,
  onTeamChange,
}) => {
  const teamsList = formatTeamsData(data);

  const handleChange = (e) => {
    let selectedValues = [...e.target.value];
    let lastSelected = selectedValues[selectedValues.length - 1];
    let teamRawData = data;
    const updatedSelectedValues = new Set(selectedValues);

    const deselectChildren = (parent, teams) => {
      teams.forEach((team) => {
        if (team.Parent === parent) {
          team.teams.forEach((child) => {
            updatedSelectedValues.delete(child.Parent);
            deselectChildren(child.Parent, teams);
          });
        } else if (team.teams.length > 0) {
          deselectChildren(parent, team.teams);
        }
      });
    };

    const deselectParents = (child, teams) => {
      for (const team of teams) {
        if (team.teams.some((subTeam) => subTeam.Parent === child)) {
          updatedSelectedValues.delete(team.Parent);
          deselectParents(team.Parent, teamRawData);
        }
        deselectParents(child, team.teams);
      }
    };

    if (lastSelected) {
      deselectChildren(lastSelected, teamRawData);
      deselectParents(lastSelected, teamRawData);
    }

    onTeamChange(e.target.value);
  };

  return (
    <FormControl fullWidth disabled={disabled} variant="outlined">
      <Select
        value={value}
        onChange={handleChange}
        name={name}
        renderValue={(selected) => {
          if (!selected || selected.length === 0) {
            return <span style={{ color: "#aaa" }}>Please select team</span>;
          }
          return renderValue ? renderValue(selected) : selected.join(", ");
        }}
        displayEmpty
        variant="outlined"
        style={{ borderRadius: 8 }}
      >
        {/* Placeholder MenuItem */}
        {/* <MenuItem value="" disabled>
          Please select team
        </MenuItem> */}

        {teamsList.map((option) => (
          <MenuItem
            key={getOptionValue(option)}
            value={option.label}
            style={{ marginLeft: `${option.indent * 1}rem` }}
          >
            {getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TeamFilterHierarchyOutlined;
